module.exports = __webpack_public_path__ + "static/media/logo.9e718389.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/core/assets/logo.jpeg
// module id = 503
// module chunks = 0